<template>
  <span class="notif-cart-icon icon-basket-wrapper">
    <span class="icon-basket-img">
      <span class="icon-basket-count" :class="{pulse1 : pulse}">{{totalItems}}</span>
    </span>
  </span>
</template>
 
<script>
  export default {

    data: function () { return { pulse: false, timer : null } },

    props: { totalItems: Number },

    watch: {
      "totalItems": function (val) {
        var vm = this;
        this.pulse = true;
        if (this.timer != null) {
          window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () { vm.pulse = false; vm.timer = null }, 800);
      }
    }

  }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/basket-count.vue